module.exports = "//static.hsappstatic.net/ui-addon-upgrades/static-9.10304/js/img/SalesHub_Icon.svg"